import type { ContentTypeDefinition } from '../../../lib/flotiq-client/types/api-response';

export type RefreshPhase = 'idle' | 'outdated' | 'restoring';

export type RefreshState = {
  phase: RefreshPhase;
  refreshedContentType: ContentTypeDefinition | null;
  pendingCompatibleValues: Record<string, unknown> | null;
};

export type RefreshAction =
  | { type: 'reset' }
  | { type: 'detected' }
  | {
      type: 'apply';
      contentType: ContentTypeDefinition;
      compatibleValues: Record<string, unknown>;
    }
  | { type: 'restored' };

export const initialRefreshState: RefreshState = {
  phase: 'idle',
  refreshedContentType: null,
  pendingCompatibleValues: null,
};

export const refreshReducer = (
  state: RefreshState,
  action: RefreshAction,
): RefreshState => {
  switch (action.type) {
    case 'reset':
      return initialRefreshState;
    case 'detected':
      return { ...state, phase: 'outdated' };
    case 'apply':
      return {
        phase: 'restoring',
        refreshedContentType: action.contentType,
        pendingCompatibleValues: action.compatibleValues,
      };
    case 'restored':
      return { ...state, phase: 'idle', pendingCompatibleValues: null };
    default:
      return state;
  }
};
